/* Cart v4 is loaded only by ajax-cart-v4.liquid. It never binds to legacy cart markup. */
(function(window, document) {
  'use strict';

  var configNode = document.getElementById('GgCartV4Config');
  if (!configNode) return;

  var config;
  try {
    config = JSON.parse(configNode.textContent);
  } catch (error) {
    return;
  }

  var state = { cart: null, protectionSelected: null, pageScrollY: null, pageScrollTopStyle: '' };

  function getRoot() {
    return document.querySelector('[data-gg-cart-v4]');
  }

  function renderEmptyCart() {
    var container = document.getElementById('CartContainer');
    if (!container) return;
    container.innerHTML =
      '<div class="gg-cart-v4 gg-cart-v4--empty" data-gg-cart-v4>' +
        '<button type="button" class="gg-cart-v4__close js-drawer-close" data-gg-v4-close aria-label="Close cart"><span aria-hidden="true">×</span></button>' +
        '<p class="gg-cart-v4__empty-message">Your cart is empty</p>' +
      '</div>';
  }

  function formatMoney(cents) {
    if (window.theme && theme.Currency && theme.Currency.formatMoney) {
      return theme.Currency.formatMoney(cents, theme.strings.moneyFormat);
    }
    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }

  function request(url, body) {
    return window.fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function(response) {
      if (!response.ok) {
        return response.json().catch(function() { return {}; }).then(function(error) {
          throw new Error(error.description || error.message || 'Something went wrong. Please try again.');
        });
      }
      return response.json();
    });
  }

  function getCart() {
    return window.fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function(response) {
        if (!response.ok) throw new Error('Unable to refresh your cart.');
        return response.json();
      });
  }

  function isManagedProtection(item) {
    var protection = config.protection || {};
    if (!protection.enabled || !protection.variantId) return false;
    return Number(item.variant_id) === Number(protection.variantId) ||
      Boolean(item.properties && item.properties._gg_cart_v4_shipping_protection);
  }

  function getProtectionLines(cart) {
    return (cart.items || []).filter(isManagedProtection);
  }

  function setCheckoutLabel(root, cents) {
    var label = root.querySelector('[data-gg-v4-checkout-label]');
    if (label) label.textContent = 'CHECKOUT · ' + formatMoney(cents);
  }

  function syncShipping(root, cart, protectionLines) {
    var shipping = config.shipping || {};
    var threshold = Number(shipping.thresholdCents || 0);
    var managedTotal = protectionLines.reduce(function(total, line) { return total + Number(line.final_line_price || 0); }, 0);
    var qualifyingTotal = Math.max(0, Number(cart.total_price || 0) - managedTotal);
    var unlocked = threshold <= 0 || qualifyingTotal >= threshold;
    var heading = root.querySelector('[data-gg-v4-shipping-heading]');
    var text = root.querySelector('[data-gg-v4-shipping-text]');
    var progress = root.querySelector('[data-gg-v4-shipping-progress]');
    var remainder = Math.max(0, threshold - qualifyingTotal);

    if (heading) heading.textContent = unlocked ? shipping.unlockedHeading : String(shipping.lockedHeading || '').replace('[amount]', formatMoney(remainder));
    if (text) text.textContent = unlocked ? shipping.unlockedText : shipping.lockedText;
    if (progress) progress.style.width = (unlocked ? 100 : Math.max(2, Math.min(100, (qualifyingTotal / threshold) * 100))) + '%';
  }

  function syncItems(root, cart, protectionLines) {
    var linesByKey = {};
    (cart.items || []).forEach(function(line) { linesByKey[line.key] = line; });

    Array.prototype.forEach.call(root.querySelectorAll('.gg-cart-v4__item'), function(row) {
      var line = linesByKey[row.getAttribute('data-key')];
      var saving = row.querySelector('[data-gg-v4-saving]');
      if (line && isManagedProtection(line)) {
        row.classList.add('is-hidden-managed-bump');
        row.setAttribute('aria-hidden', 'true');
        return;
      }
      row.classList.remove('is-hidden-managed-bump');
      row.removeAttribute('aria-hidden');
      if (!line || !saving) return;
      var savingCents = Math.max(0, Number(line.original_line_price || 0) - Number(line.final_line_price || 0));
      saving.hidden = savingCents === 0;
      saving.textContent = savingCents ? '(You save ' + formatMoney(savingCents) + ')' : '';
    });
  }

  function syncUpsells(root, cart) {
    Array.prototype.forEach.call(root.querySelectorAll('[data-gg-v4-upsell]'), function(upsell) {
      var productId = Number(upsell.getAttribute('data-product-id'));
      var isInCart = (cart.items || []).some(function(item) { return Number(item.product_id) === productId; });
      upsell.hidden = !productId || isInCart;
    });
  }

  function syncInCartOffer(root, cart) {
    var offer = root.querySelector('[data-gg-v4-in-cart-offer]');
    if (!offer) return;
    var productId = Number(offer.getAttribute('data-product-id'));
    var qualifyingQuantity = Number(offer.getAttribute('data-qualifying-quantity'));
    var matches = (cart.items || []).filter(function(item) {
      return Number(item.product_id) === productId && !isManagedProtection(item);
    });
    var matchingQuantity = matches.reduce(function(total, item) {
      return total + Number(item.quantity || 0);
    }, 0);
    // Only offer the 1 → 2 incentive for a single matching line at exactly
    // the configured qualifying quantity. Any higher quantity (including 4)
    // or split product lines keeps the offer hidden.
    var qualifyingLine = matches.length === 1 && matchingQuantity === qualifyingQuantity ? matches[0] : null;
    offer.hidden = !qualifyingLine;
    offer.setAttribute('data-line-key', qualifyingLine ? qualifyingLine.key : '');
  }

  function syncProtection(root, cart, protectionLines) {
    var protection = root.querySelector('[data-gg-v4-protection]');
    if (!protection) return { selected: false, managedTotal: 0, priceCents: 0 };
    var toggle = protection.querySelector('[data-gg-v4-protection-toggle]');
    var defaultOn = protection.getAttribute('data-default-on') === 'true';
    var configuredPrice = Number((config.protection || {}).priceCents || 0);
    var renderedPrice = Number(protection.getAttribute('data-price-cents') || 0);
    if (state.protectionSelected === null) state.protectionSelected = protectionLines.length > 0 || defaultOn;
    if (toggle) toggle.checked = state.protectionSelected;
    return {
      selected: state.protectionSelected,
      managedTotal: protectionLines.reduce(function(total, line) { return total + Number(line.final_line_price || 0); }, 0),
      priceCents: renderedPrice || configuredPrice
    };
  }

  function sync(root, cart) {
    if (!root || !cart) return;
    state.cart = cart;
    var protectionLines = getProtectionLines(cart);
    syncShipping(root, cart, protectionLines);
    syncItems(root, cart, protectionLines);
    syncUpsells(root, cart);
    syncInCartOffer(root, cart);
    var protectionState = syncProtection(root, cart, protectionLines);
    var baseTotal = Math.max(0, Number(cart.total_price || 0) - protectionState.managedTotal);
    // The live cart total already includes a protection line when present.
    // When it is not in the cart yet, add its configured rendered price only
    // while the footer toggle is on, so the checkout price always previews it.
    var protectionPrice = protectionLines.length ? protectionState.managedTotal : protectionState.priceCents;
    setCheckoutLabel(root, baseTotal + (protectionState.selected ? protectionPrice : 0));
    root.classList.add('is-ready');
    var inner = root.querySelector('.gg-cart-v4__inner');
    if (inner) inner.setAttribute('aria-busy', 'false');
    if (window.theme && typeof theme.sizeCartDrawerFooter === 'function') theme.sizeCartDrawerFooter();
  }

  function refreshDrawer() {
    if (window.ajaxCart && typeof window.ajaxCart.load === 'function') {
      window.ajaxCart.load();
      return;
    }
    getCart().then(function(cart) { sync(getRoot(), cart); });
  }

  function setButtonLoading(button, loading) {
    if (!button) return;
    button.disabled = loading;
    button.classList.toggle('is-loading', loading);
    var label = button.querySelector('[data-gg-v4-checkout-label]');
    if (loading && label) label.textContent = 'SECURING CHECKOUT…';
  }

  function setQuantityLoading(control) {
    var quantityControl = control.closest('.gg-cart-v4__qty');
    if (!quantityControl || quantityControl.classList.contains('is-loading')) return;
    quantityControl.classList.add('is-loading');
    quantityControl.setAttribute('aria-busy', 'true');
    Array.prototype.forEach.call(quantityControl.querySelectorAll('button'), function(button) {
      // Do not set the native disabled property here: the legacy Ajax Cart
      // handler is delegated and will skip a disabled click before updating.
      button.setAttribute('aria-disabled', 'true');
    });

    // The normal Ajax Cart redraw replaces this element after its request
    // succeeds. Clear the lock if that request fails without a redraw.
    window.setTimeout(function() {
      if (!document.documentElement.contains(quantityControl)) return;
      quantityControl.classList.remove('is-loading');
      quantityControl.setAttribute('aria-busy', 'false');
      Array.prototype.forEach.call(quantityControl.querySelectorAll('button'), function(button) {
        button.removeAttribute('aria-disabled');
      });
    }, 8000);
  }

  function showCheckoutError(root, message) {
    var error = root.querySelector('[data-gg-v4-checkout-error]');
    if (!error) return;
    error.textContent = message;
    error.hidden = false;
  }

  function closeDrawer() {
    var drawer = window.timber && window.timber.RightDrawer;
    document.body.classList.remove('gg-cart-v4-open');
    unlockPageScroll();
    if (drawer && drawer.drawerIsOpen && typeof drawer.close === 'function') {
      // Timber's close method expects an event-like object, but the V4 close
      // control is rendered after Timber binds its original close controls.
      drawer.close({ keyCode: 0, preventDefault: function() {} });
      return;
    }
    document.documentElement.classList.remove('js-drawer-open', 'js-drawer-open-right');
    document.body.classList.remove('js-drawer-open', 'js-drawer-open-right');
    var drawerElement = document.getElementById('CartDrawer');
    if (drawerElement) drawerElement.classList.remove('js-drawer-open');
  }

  function lockPageScroll() {
    if (!isV4DrawerOpen() || !window.matchMedia || !window.matchMedia('(max-width: 767px)').matches || state.pageScrollY !== null) return;
    state.pageScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    state.pageScrollTopStyle = document.body.style.top;
    document.documentElement.classList.add('gg-cart-v4-scroll-locked');
    document.body.classList.add('gg-cart-v4-scroll-locked');
    document.body.style.top = '-' + state.pageScrollY + 'px';
  }

  function unlockPageScroll() {
    if (state.pageScrollY === null) return;
    var scrollY = state.pageScrollY;
    state.pageScrollY = null;
    document.documentElement.classList.remove('gg-cart-v4-scroll-locked');
    document.body.classList.remove('gg-cart-v4-scroll-locked');
    document.body.style.top = state.pageScrollTopStyle;
    state.pageScrollTopStyle = '';
    window.scrollTo(0, scrollY);
  }

  function isV4DrawerOpen() {
    var drawer = document.getElementById('CartDrawer');
    return Boolean(
      drawer &&
      document.body.classList.contains('gg-cart-v4-open') &&
      document.body.classList.contains('js-drawer-open-right') &&
      drawer.classList.contains('js-drawer-open')
    );
  }

  function syncPageScrollLock() {
    var isMobile = !window.matchMedia || window.matchMedia('(max-width: 767px)').matches;
    if (isV4DrawerOpen() && isMobile) {
      lockPageScroll();
    } else {
      unlockPageScroll();
    }
  }

  function reconcileProtection(cart, selected) {
    var protection = config.protection || {};
    if (!protection.enabled || !protection.variantId) return Promise.resolve(cart);
    var managedLines = getProtectionLines(cart);
    if (selected && managedLines.length === 0) {
      return request('/cart/add.js', { items: [{ id: protection.variantId, quantity: 1, properties: { _gg_cart_v4_shipping_protection: 'true' } }] });
    }
    if (!selected && managedLines.length) {
      return Promise.all(managedLines.map(function(line) {
        return request('/cart/change.js', { id: line.key, quantity: 0 });
      }));
    }
    return Promise.resolve(cart);
  }

  function onCheckout(root, button) {
    var toggle = root.querySelector('[data-gg-v4-protection-toggle]');
    var selected = toggle ? toggle.checked : false;
    var error = root.querySelector('[data-gg-v4-checkout-error]');
    if (error) error.hidden = true;
    setButtonLoading(button, true);

    getCart()
      .then(function(cart) { return reconcileProtection(cart, selected); })
      .then(function() { return getCart(); })
      .then(function() { window.location.assign('/checkout'); })
      .catch(function(error) {
        setButtonLoading(button, false);
        showCheckoutError(root, error.message || 'We could not prepare your checkout. Please try again.');
        getCart().then(function(cart) { sync(root, cart); });
      });
  }

  document.addEventListener('change', function(event) {
    if (!event.target.matches('[data-gg-v4-protection-toggle]')) return;
    state.protectionSelected = event.target.checked;
    if (state.cart) {
      sync(getRoot(), state.cart);
      return;
    }
    getCart().then(function(cart) { sync(getRoot(), cart); });
  });

  // Capture phase runs before the legacy delegated Ajax Cart handlers, so
  // feedback appears immediately when a shopper presses + or −.
  document.addEventListener('click', function(event) {
    var quantityButton = event.target.closest('.gg-cart-v4__qty .ajaxcart__qty-adjust');
    if (!quantityButton) return;
    if (quantityButton.closest('.gg-cart-v4__qty').classList.contains('is-loading')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    setQuantityLoading(quantityButton);
  }, true);

  document.addEventListener('change', function(event) {
    if (event.target.matches('.gg-cart-v4__qty .ajaxcart__qty-num')) setQuantityLoading(event.target);
  }, true);

  document.addEventListener('click', function(event) {
    var close = event.target.closest('[data-gg-v4-close]');
    if (close) {
      event.preventDefault();
      closeDrawer();
      return;
    }

    var root = getRoot();
    if (!root) return;

    var remove = event.target.closest('[data-gg-v4-remove]');
    if (remove) {
      event.preventDefault();
      var lineKey = remove.getAttribute('data-key');
      if (!lineKey) return;
      remove.disabled = true;
      request('/cart/change.js', { id: lineKey, quantity: 0 })
        .then(refreshDrawer)
        .catch(function(error) {
          showCheckoutError(root, error.message || 'We could not remove that item.');
          remove.disabled = false;
        });
      return;
    }

    var upsell = event.target.closest('[data-gg-v4-upsell-add]');
    if (upsell) {
      event.preventDefault();
      if (upsell.disabled) return;
      upsell.disabled = true;
      request('/cart/add.js', { items: [{ id: Number(upsell.closest('[data-gg-v4-upsell]').getAttribute('data-variant-id')), quantity: 1 }] })
        .then(refreshDrawer)
        .catch(function(error) { showCheckoutError(root, error.message || 'We could not add that item.'); upsell.disabled = false; });
      return;
    }

    var offer = event.target.closest('[data-gg-v4-in-cart-offer-add]');
    if (offer) {
      event.preventDefault();
      var offerBox = offer.closest('[data-gg-v4-in-cart-offer]');
      var targetQuantity = Number(offerBox.getAttribute('data-target-quantity'));
      var lineKey = offerBox.getAttribute('data-line-key');
      if (!lineKey) return;
      offer.disabled = true;
      request('/cart/change.js', { id: lineKey, quantity: targetQuantity })
        .then(refreshDrawer)
        .catch(function(error) { showCheckoutError(root, error.message || 'We could not update your cart.'); offer.disabled = false; });
      return;
    }

    var checkout = event.target.closest('[data-gg-v4-checkout]');
    if (checkout) {
      event.preventDefault();
      if (!checkout.disabled) onCheckout(root, checkout);
    }
  });

  if (window.jQuery) {
    window.jQuery(document.body).on('ajaxCart.afterCartLoad', function(event, cart) {
      document.body.classList.add('gg-cart-v4-open');
      window.setTimeout(syncPageScrollLock, 0);
      if (Number(cart.item_count || 0) === 0) {
        state.cart = cart;
        state.protectionSelected = null;
        renderEmptyCart();
        return;
      }
      sync(getRoot(), cart);
    });
  }

  // Escape and page-click closes are owned by the legacy drawer. Reconcile
  // against both body and drawer states so V4 can never leave a stale lock.
  if (window.MutationObserver) {
    new window.MutationObserver(function() {
      syncPageScrollLock();
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    var v4Drawer = document.getElementById('CartDrawer');
    if (v4Drawer) {
      new window.MutationObserver(syncPageScrollLock)
        .observe(v4Drawer, { attributes: true, attributeFilter: ['class'] });
    }
  }

  window.addEventListener('resize', function() {
    syncPageScrollLock();
  });
})(window, document);
